<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        @onClick="abrirForm"
      />
      <div v-if="formOpen">
        <usuarioForm :usuario="usuario" :salvar="salvar" :formsubmit="formsubmit" />
      </div>
      <div v-else>
        <Table
          :search="true"
          :form-open="formOpen"
          :tables-fields="usuariosFields"
          :table-items="usuarios"
          @onEdit="edit"
          @onDelete="onDelete"
        />
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import usuarioForm from '../../../../components/forms/usuarioForm.vue'
import Table from '@/src/components/tables/table-register.vue'
import alertMixin from '@/src/mixins/alertMixin'
import usuarioMixin from '@/src/mixins/usuarioMixin'

export default {
  components: { Layout, HeaderPage, usuarioForm, Table },
  mixins: [alertMixin, usuarioMixin],
  data() {
    return {
      isLoading: false,
      pageTitles: {
        title: 'Cadastro De Usuários',
        subtitle: 'Registre seus usuários aqui',
      },
      formOpen: false,
      item: '',
      usuario: {},
      usuarios: [],
      formsubmit: false,
    }
  },
  mounted() {
    this.listaUsuario()
  },
  methods: {
    abrirForm() {
      this.formOpen = !this.formOpen
      this.usuario = {}
      this.formsubmit = false
    },
    listaUsuario() {
      this.isLoading = true
      this.loadUsuarios().then((res) => {
        this.usuarios = res.data.dados
        this.isLoading = false
      })
    },
    edit(item) {
      this.abrirForm()
      this.usuario = item
    },
    salvar() {
      this.isLoading = true
      if (!this.usuario._id) {
        this.registerUsuario(this.usuario)
          .then((response) => {
            //this.successMessage(response.data.message?response.data.message:'Cadastrado com sucesso')
            this.abrirForm()
            this.usuario = {}
            this.listaUsuario()
            this.isLoading = false
          })
          .catch((err) => {
            this.errorMessage(err.response.data.mensagem?err.response.data.mensagem:'Erro inesperado.')
            this.isLoading = false
          })
      } else {
        delete this.usuario['senha']
        this.editUsuario(this.usuario._id, this.usuario).then((res) => {
          if(response){
            this.successMessage(res.data.message?res.data.message:'usuário atualizado com Sucesso')
            this.abrirForm()
            this.usuario = {}
            this.listaUsuario()
            this.isLoading = false
          }
        })
        .catch((err) => {
          this.errorMessage(err.response.data.mensagem?err.response.data.mensagem:'Erro inesperado.')
          this.isLoading = false
        })
      }
    },
    onDelete(id) {
      this.isLoading = true
      this.deleteUsuario(id).then(()=>{
        this.successMessage('usuário removido com sucesso')
        this.listaUsuario()
        this.usuario = {}
        this.isLoading = true
      }) 
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
